import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import GossipList from '../pages/gossip/page';
import GossipDetail from '../pages/gossip/detail/page';
import Community from '../pages/community/page';
import FaqPage from '../pages/faq/page';
import About from '../pages/about/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/gossip',
    element: <GossipList />,
  },
  {
    path: '/gossip/:id',
    element: <GossipDetail />,
  },
  {
    path: '/community',
    element: <Community />,
  },
  {
    path: '/faq',
    element: <FaqPage />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;